import { render, staticRenderFns } from "./BudgetMetrics.vue?vue&type=template&id=f55cac4a&scoped=true&"
import script from "./BudgetMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetMetrics.vue?vue&type=style&index=0&id=f55cac4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55cac4a",
  null
  
)

export default component.exports